import React from 'react'

import { Text } from '@wartek-id/text'
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleIcon,
  CollapsibleContent,
} from '@wartek-id/collapsible'

import type { FAQItemProps } from '../../types/faq'

const FAQ4 = (props: FAQItemProps) => {
  return (
    <Collapsible {...props}>
      <CollapsibleTrigger className="!text-left">
        <Text variant="body-sm" className="!font-semibold">
          Bagaimana cara menggunakan Asesmen di Platform Ruang GTK?
        </Text>
        <CollapsibleIcon></CollapsibleIcon>
      </CollapsibleTrigger>
      <CollapsibleContent className="p-4">
        <Text className="mb-6">
          Berikut langkah-langkah menggunakan menu Asesmen Murid:
          <ol className="list-decimal ml-5">
            <li>
              Pilih menu <b>Asesmen Murid</b> pada halaman Beranda platform
              Ruang GTK
            </li>
            <li>
              Pilih <b>Asesmen Pembelajaran</b> atau <b>AKM Kelas</b> sesuai
              kebutuhan
            </li>
          </ol>
          Informasi selengkapnya dapat dilihat pada halaman{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href={
              process.env.NEXT_PUBLIC_PUSAT_INFORMASI_RUMDIK_BASE_URL +
              '/hc/id/sections/52398093679001-Asesmen-Murid'
            }
          >
            <Text
              as="span"
              color="primary"
              className="!text-[16px] hover:underline"
            >
              Pusat Informasi
            </Text>
          </a>
          .
        </Text>
      </CollapsibleContent>
    </Collapsible>
  )
}

export default FAQ4
